module.exports = __webpack_public_path__ + "img/value1.851d515b.webp";